export let life = {
  created () {
    this.methods('preloadingPlugins') // 预加载裁剪插件
  }
}
export let event = {
  clickChooise () {
    this.methods('clickChooise')
  },
  clickCut () {
    this.methods('destroyCropper')
  },
  inputChange () {
    this.methods('afterChange')
  }
}
export let watch = {
  value () {
    this.methods('imgValueChange')
  }
}
